<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2">
                <label>{{ $t('common_words.report_type') }}*</label>
                <br />
                <el-select
                  class="select-primary custom-width-select required-type shadow-sm"
                  size="large"
                  @clear="boxReportForm.type = null"
                  clearable
                  @change="boxReport = false"
                  v-model="boxReportForm.type"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsReport"
                    :key="option.id"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  multiple
                  :multiple-limit="1"
                  v-bind:collapse-tags="true"
                  filterable
                  clearable
                  @clear="boxReportForm.farms = []"
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="boxReportForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="`farm-${option.id}-${index}`"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  @change="changeByInterval"
                  @clear="boxReportForm.bySel = null"
                  filterable
                  clearable
                  class="select-primary custom-width-select required-bySel shadow-sm"
                  size="large"
                  v-model="boxReportForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  boxReportForm.bySel &&
                  boxReportForm.bySel != 'week' &&
                  boxReportForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  clearable
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' || boxReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="boxReportForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="boxReportForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 100 + 1"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' && boxReportForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="boxReportForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[boxReportForm.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 200 + 2"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' || boxReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="boxReportForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="boxReportForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 300 + 4"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' && boxReportForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="boxReportForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[boxReportForm.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 400 + 6"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br
        v-if="Object.keys(chartOptions[0]).length > 0 && tableData.length > 0"
      />
      <template v-if="boxReport">
        <card
          class="custom-shadow-card-header"
          v-if="Object.keys(chartOptions[0]).length > 0 && tableData.length > 0"
        >
          <div>
            <div class="row">
              <chart-header-options
                :chartData="chartOptions[0]"
                @handleLoadChartOptions="handleLoadChartOptions"
              />
              <div class="col-12">
                <highcharts :options="chartOptions[0]"></highcharts>
              </div>
            </div>
          </div>
        </card>
        <br
          v-if="Object.keys(chartOptions[1]).length > 0 && tableData.length > 0"
        />
        <card
          class="custom-shadow-card-header"
          v-if="Object.keys(chartOptions[1]).length > 0 && tableData.length > 0"
        >
          <div>
            <chart-header-options
              :chartData="chartOptions[1]"
              :index="1"
              @handleLoadChartOptions="handleLoadChartOptions"
            />
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions[1]"></highcharts>
              </div>
            </div>
          </div>
        </card>
        <br
          v-if="Object.keys(chartOptions[2]).length > 0 && tableData.length > 0"
        />
        <card
          class="custom-shadow-card-header"
          v-if="Object.keys(chartOptions[2]).length > 0 && tableData.length > 0"
        >
          <div>
            <div class="row">
              <chart-header-options
                :chartData="chartOptions[2]"
                :index="2"
                @handleLoadChartOptions="handleLoadChartOptions"
              />
              <div class="col-12">
                <highcharts :options="chartOptions[2]"></highcharts>
              </div>
            </div>
          </div>
        </card>
        <br
          v-if="Object.keys(chartOptions[3]).length > 0 && tableData.length > 0"
        />
        <card
          class="custom-shadow-card-header"
          v-if="Object.keys(chartOptions[3]).length > 0 && tableData.length > 0"
        >
          <div>
            <div class="row">
              <chart-header-options
                :chartData="chartOptions[3]"
                :index="3"
                @handleLoadChartOptions="handleLoadChartOptions"
              />
              <div class="col-12">
                <highcharts :options="chartOptions[3]"></highcharts>
              </div>
            </div>
          </div>
        </card>
        <br
          v-if="Object.keys(chartOptions[4]).length > 0 && tableData.length > 0"
        />
        <card
          class="custom-shadow-card-header"
          v-if="Object.keys(chartOptions[4]).length > 0 && tableData.length > 0"
        >
          <div>
            <div class="row">
              <chart-header-options
                :chartData="chartOptions[4]"
                :index="4"
                @handleLoadChartOptions="handleLoadChartOptions"
              />
              <div class="col-12">
                <highcharts :options="chartOptions[4]"></highcharts>
              </div>
            </div>
          </div>
        </card>
        <br
          v-if="Object.keys(chartOptions[5]).length > 0 && tableData.length > 0"
        />
        <card
          class="custom-shadow-card-header"
          v-if="Object.keys(chartOptions[5]).length > 0 && tableData.length > 0"
        >
          <div>
            <div class="row">
              <chart-header-options
                :chartData="chartOptions[5]"
                :index="5"
                @handleLoadChartOptions="handleLoadChartOptions"
              />
              <div class="col-12">
                <highcharts :options="chartOptions[5]"></highcharts>
              </div>
            </div>
          </div>
        </card>
        <br />
        <card class="custom-shadow-card-header">
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :border="true"
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                height="350"
                style="width: 100%"
                :cell-style="finalCellStyle"
              >
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="index"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :formatter="formatNumberTable"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { MixinExport } from 'src/mixins/mixin-export';
import ChartHeaderOptions from 'src/components/Chart/ChartHeaderOptions.vue';
import exportingInit from 'highcharts/modules/exporting';
import Formatter from 'src/class/Formatter';
import Highcharts from 'highcharts';
import mixinCharts from 'src/util/mixinCharts';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

exportingInit(Highcharts);

export default {
  components: {
    [ChartHeaderOptions.name]: ChartHeaderOptions,
    highcharts: Chart,
  },

  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    optionsReport() {
      return [
        { id: 'GENERAL', name: i18n.t('common_words.general_mayus') },
        {
          id: 'MUESTREO DETALLADO',
          name: i18n.t('common_words.sampling_detailed_mayus'),
        },
        {
          id: 'MUESTREO CONSOLIDADO',
          name: i18n.t('common_words.sampling_consolidated_mayus'),
        },
        { id: 'LOTE', name: i18n.t('common_words.mayus_allotment') },
        { id: 'RECOBRO', name: i18n.t('production.payment_due_mayus') },
        { id: 'RECHAZO', name: i18n.t('production.rejected_mayus') },
        {
          id: 'PESO LOTE SEMANAL',
          name: i18n.t('common_words.allotment_weekly_weight_mayus'),
        },
      ];
    },

    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
  },

  data() {
    return {
      boxReportForm: {
        bySel: null,
      },
      chartOptions: [{}, {}, {}, {}, {}, {}],
      activeName: '1',
      typedatepicket: 'daterange',
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      boxReport: false,
      titleCard: '',
      tableColumns: null,
      chartsData: [],
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinDatePicker,
    mixinCharts,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    handleLoadChartOptions(data) {
      this.$set(this.chartOptions, data.index, data.chartData);
    },

    finalCellStyle: function ({ row, column, rowIndex, columnIndex }) {
      switch (this.boxReportForm.type) {
        case 'MUESTREO CONSOLIDADO':
          if (columnIndex == 1) {
            return {
              'background-color': row['color_code'],
              color: row['color_code'],
            };
          }

          break;
        case 'MUESTREO DETALLADO':
        case 'RECOBRO':
          if (columnIndex == 2) {
            return {
              'background-color': row['color_code'],
              color: row['color_code'],
            };
          }

          break;
      }
    },

    changeByInterval() {
      this.boxReport = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.boxReportForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      this.boxReportForm.calendar_sel = this.rangeDate;

      if (this.boxReportForm.type == null) {
        return this.validationInputsRequired('type');
      }
      if (this.boxReportForm.bySel == null) {
        return this.validationInputsRequired('bySel');
      } else if (
        this.boxReportForm.farms == null ||
        this.boxReportForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.boxReportForm.bySel == 'year' &&
          (this.boxReportForm.year_sel_init == null ||
            this.boxReportForm.year_sel_end == null)) ||
        (this.boxReportForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.boxReportForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.boxReportForm.week_sel_init == null &&
        this.boxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.boxReportForm.year_sel_end == null &&
        this.boxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.boxReportForm.week_sel_end == null &&
        this.boxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.boxReportForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.chartOptions = [{}, {}, {}, {}, {}, {}];
        this.loadClusterReport();
      }
    },

    formatNumberTable(row, column) {
      return typeof row[column.property] === 'string' ||
        row[column.property] instanceof String
        ? row[column.property]
        : Formatter.formatMoney(row[column.property]);
    },

    loadData() {
      let data = {
        type: this.boxReportForm.type,
        farms: this.boxReportForm.farms,
        init:
          parseInt(this.boxReportForm.year_sel_init) * 100 +
          parseInt(this.boxReportForm.week_sel_init),
        end:
          parseInt(this.boxReportForm.year_sel_end) * 100 +
          parseInt(this.boxReportForm.week_sel_end),
        bySel: this.boxReportForm.bySel,
      };

      switch (this.boxReportForm.bySel) {
        case 'year':
          data.init = parseInt(this.boxReportForm.year_sel_init);
          data.end = parseInt(this.boxReportForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('YYYYMM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('YYYYMM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadClusterReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'scales/clusters/reports';

      Axios.saveMaster(data)
        .then((response) => {
          if (response.data) {
            this.chartsData = response.data;
            this.tableData = this.chartsData.table_data;
            if (this.tableData.length == 0) {
              SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            } else {
              this.tableColumns = this.chartsData.table_columns;
              this.searchFuse(
                this.chartsData.table_columns.map((prop) => {
                  return prop.prop;
                })
              );

              switch (this.boxReportForm.type) {
                case 'GENERAL':
                case 'LOTE':
                  this.chartOptions[0] = this.columns(
                    this.chartsData.column_chart1
                  );
                  this.chartOptions[1] = this.columns(
                    this.chartsData.column_chart2
                  );
                  break;
                case 'MUESTREO CONSOLIDADO':
                case 'MUESTREO DETALLADO':
                case 'RECOBRO':
                  this.chartOptions[0] = this.columns(
                    this.chartsData.column_chart1
                  );
                  this.chartOptions[1] = this.columns(
                    this.chartsData.column_chart2
                  );
                  this.chartOptions[2] = this.columns(
                    this.chartsData.column_chart3
                  );
                  this.chartOptions[3] = this.columns(
                    this.chartsData.column_chart4
                  );
                  this.chartOptions[4] = this.columns(
                    this.chartsData.column_chart5
                  );
                  this.chartOptions[5] = this.columns(
                    this.chartsData.column_chart6
                  );
                  break;
                case 'RECHAZO':
                  this.chartOptions[0] = this.columns(
                    this.chartsData.column_chart1
                  );
                  this.chartOptions[1] = this.columns(
                    this.chartsData.column_chart2
                  );
                  this.chartOptions[2] = this.columns(
                    this.chartsData.column_chart3
                  );
                  break;
              }

              this.boxReport = true;
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },

    exportPDF() {
      let data = this.loadData();
      data.route = 'scales/clusters/reports/pdf';
      data.name_file = `${i18n.t('production.cluster_fruit_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'scales/clusters/reports/excel';
      data.name_file = `${i18n.t('production.cluster_fruit_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          Axios.getMasters('calendars/getyearsbusiness')
            .then((response1) => {
              this.farms = response.data.data;
              this.years = response1.data;
              this.showHideLoading();
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    this.deselectedItemOnMenu('scales');
  },
};
</script>
